import instance from "./axios";
import baseUrl from "@/env";

export async function pageErrorQuestionList(data) {
  const res = await instance.get(
    `${baseUrl}/question/pageErrorQuestionList?courseSerialnumber=${data.courseSerialnumber}&pageSize=${data.pageSize}&pageNumber=${data.pageNumber}`
  );

  return res.data;
}

export async function getQuestionListByErrorQuestionId(params) {
  const query = [
    `questionId=${params.questionId}`,
    `type=${params.type}`,
    `level=${params.level}`,
    `qtype=${params.qtype}`,
    `courseSerialnumber=${params.courseSerialnumber}`,
    `knowledgeSerialnumber=${params.knowledgeSerialnumber}`
  ].join("&");
  const res = await instance.get(
    `${baseUrl}/courseManager/getQuestionListByErrorQuestionId?${query}`
  );
  return res.data;
}

export async function getStudentPortrait(params = {}) {
  const query = [
    `courseSerialnumber=${encodeURIComponent(params.courseSerialnumber || "")}`,
    `startTime=${encodeURIComponent(params.startTime || "")}`,
    `endTime=${encodeURIComponent(params.endTime || "")}`
  ].join("&");
  const res = await instance.get(
    `${baseUrl}/question/getStudentPortrait?${query}`
  );
  return res.data;
}

export async function getMyPortrait(params = {}) {
  const query = [
    `courseSerialnumber=${encodeURIComponent(params.courseSerialnumber || "")}`,
    `startTime=${encodeURIComponent(params.startTime || "")}`,
    `endTime=${encodeURIComponent(params.endTime || "")}`
  ].join("&");
  const res = await instance.get(`${baseUrl}/student/portrait/my?${query}`);
  return res.data;
}
